<ng-container
    *ngIf="type === 'section'; then sectionTemplate; else productTemplate"
></ng-container>

<ng-template #sectionTemplate>
    <h5 *ngIf="!root">{{ section.name.displayName }}</h5>

    <!-- Icons -->
    <div
        class="zbd-icon-group"
        [ngClass]="{
            'spacing-fix': groupedSubsections.iconSections.length && root,
        }"
    >
        <!-- 3 columns -->
        <div
            picker-icon
            class="visible-xs-block visible-md-block visible-lg-block"
            *ngFor="
                let subsection of groupedSubsections.iconSections;
                trackBy: trackSection
            "
            [env]="env"
            [section]="subsection"
        ></div>

        <!-- 4 columns -->
        <div
            picker-icon
            class="visible-sm-block"
            *ngFor="
                let subsection of groupedSubsections.iconSections;
                trackBy: trackSection
            "
            [env]="env"
            [section]="subsection"
        ></div>
    </div>

    <!-- List -->
    <ng-container
        *ngFor="
            let subsection of groupedSubsections.regularSections;
            trackBy: trackSection;
            let first = first
        "
    >
        <ng-container [ngSwitch]="getSectionType(subsection)">
            <div
                picker-section
                *ngSwitchCase="'section'"
                [env]="env"
                [section]="subsection"
                [root]="false"
            ></div>
            <div
                picker-product
                *ngSwitchCase="'product'"
                [ngClass]="{
                    'spacing-fix':
                        first &&
                        !groupedSubsections.iconSections.length &&
                        root,
                }"
                [env]="env"
                [section]="subsection"
                [root]="false"
            ></div>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #productTemplate>
    <div *ngIf="section.canAdd" class="title">
        <a class="title clearfix" (click)="createDivision()">
            {{ section.name.displayName }}
            <span class="zas-header-icon icon-add pull-right"></span>
        </a>
    </div>
    <div *ngIf="!section.canAdd" class="title">
        <span class="title">{{ section.name.displayName }}</span>
    </div>
</ng-template>
